module.exports = __webpack_public_path__ + "media/library_item_types/computer-8629f0c9.png";